// Project Imports
import RulesDashboardResource from 'core/resources/RulesDashboard';
import RulePlansResource from 'core/resources/RulePlans';
// import RuleGroupsResource from 'core/resources/RuleGroups';
// import RulesResource from 'core/resources/Rules';
import ProgramResource from 'core/resources/Program';
import FrequencyResource from 'core/resources/Frequency';
import WorkflowResource from 'core/resources/Workflow';
import TargetSettingConfigResource from 'core/resources/targetSettingConfigResource';
import HolidayResource from 'core/resources/holidayResource';
import TargetHierarchyResource from 'core/resources/targetHierarchyResource';
import CategoryResource from 'core/resources/categoryResource';
import UploadProductImageResource from 'core/resources/uploadProductImageResource';
import ContestResource from 'core/resources/contestResource';
import QueryConfigResource from 'core/resources/QueryConfigResource';
import ResourceItem from 'interfaces/resource';
import BulkRuleUploadResource from 'core/resources/bulkRuleUpload';
import BulkRuleDownloadResource from 'core/resources/bulkRuleDownload';
import RuleWorkflowResource from 'core/resources/RuleWorkflowResource';
import HookEventResource from 'core/resources/hookEventResource';
import HookRegistrationResource from 'core/resources/hookRegistrationResource';
import HookInstanceResource from 'core/resources/hookInstanceResouce';
import HookVariableResource from 'core/resources/hookVariableResource';
import HookCustomScreenResource from 'core/resources/hookCustomScreenResource';

const resources: ResourceItem[] = [
  RulesDashboardResource,
  RulePlansResource,
  RuleWorkflowResource,
  // RuleGroupsResource,
  // RulesResource,
  FrequencyResource,
  WorkflowResource,
  ProgramResource,
  TargetHierarchyResource,
  TargetSettingConfigResource,
  HolidayResource,
  CategoryResource,
  UploadProductImageResource,
  ContestResource,
  QueryConfigResource,
  BulkRuleUploadResource,
  BulkRuleDownloadResource,
  HookEventResource,
  HookRegistrationResource,
  HookInstanceResource,
  HookVariableResource,
  HookCustomScreenResource,
];

export default resources;
